const apiErrorMappings = {
  customer_id: { 'invalid value': 'Data telah dihapus dari sistem.' },
  marketing_user_id: { 'invalid value': 'Data telah dihapus dari sistem.' },
  expected_pickup_on: {},
  expected_delivered_on: {},
  aju_number: {},
  e_seal_number: {},
  shipment_number: { 'value is not unique': 'No. Shipment sudah terdaftar di sistem.' },
  reference_number: {},
  origin_address_id: {
    'invalid value': 'Data telah dihapus dari sistem.',
    'value not found': 'Gagal disimpan. Alamat Asal tidak ada di Data Master Alamat.',
  },
  destination_address_id: {
    'invalid value': 'Data telah dihapus dari sistem.',
    'value not found': 'Gagal disimpan. Alamat Tujuan tidak ada di Data Master Alamat.',
  },
  box_type_id: {
    'invalid value': 'Data telah dihapus dari sistem.',
    'mismatched with delivery load box type': 'Jenis box tidak sesuai dengan muatan.',
  },
  bulkDelete: { 'invalid status': 'Gagal dihapus. Ada status pengiriman selain Draf.' },
  vendor_id: { 'value not found': 'Vendor tidak ditemukan' },
  delivery_order: {
    'unauthorized external reference': {
      title: 'delivery.provider.failedToConnectAccountTitle',
      msg: 'delivery.provider.failedToConnectAccountMsg',
    },
    'connected and delivery tenant id are different': {
      title: 'delivery.provider.tenantIsDifferentTitle',
      msg: 'delivery.provider.tenantIsDifferentMsg',
    },
  },
  delivery_order_id: {
    'not invoiced': 'delivery.invoice.warningMessage.notInvoiced',
    'not internal': 'delivery.invoice.warningMessage.notInternal',
  },
  external_invoice: {
    'not found': 'delivery.invoice.warningMessage.notFound',
  },
}

export default apiErrorMappings
